import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";

interface ISimpleTextareaResizableProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    invalid?: boolean;
    minHeight?: string;
    maxHeight?: string;
}

class SimpleTextareaResizable extends BaseReactComponent<ISimpleTextareaResizableProps> {
    private textarea: HTMLTextAreaElement;
    private minHeightDefault: string = "144px";
    private maxHeightDefault: string = "300px";

    public componentDidMount(): void {
        this.resize();
    }

    public componentDidUpdate(): void {
        this.resize();
    }

    public render(): JSX.Element {
        return (
            <textarea
                {...this.getTextareaProps()}
                ref={ref => this.textarea = ref}
            />
        );
    }

    private getTextareaProps(): React.HTMLProps<HTMLTextAreaElement> {
        // get valid textarea props
        const props = { ...this.props };
        delete props.invalid;
        delete props.minHeight;
        delete props.maxHeight;

        // add classes
        props.className = `form-control simple-textarea-resizable ${this.props.className ?? ""}`;
        if (this.props.invalid)
            props.className += " invalid";

        return props;
    }

    private resize(): void {
        this.textarea.style.height = "1px"; // setting an absolute height here forces calculation of style.borderWidth
        this.textarea.style.minHeight = this.props.minHeight ?? this.minHeightDefault;
        this.textarea.style.maxHeight = this.props.maxHeight ?? this.maxHeightDefault;
        const borderTopWidth = this.normalizeBorderWidth(this.textarea.style.borderTopWidth);
        const borderBottomWidth = this.normalizeBorderWidth(this.textarea.style.borderBottomWidth);
        this.textarea.style.height = `calc(${this.textarea.scrollHeight}px + ${borderTopWidth} + ${borderBottomWidth})`;
    }

    private normalizeBorderWidth(borderWidth: string): string {
        return /^\d/.test(borderWidth) ?
            borderWidth :
            "1px";
    }
}

export { ISimpleTextareaResizableProps, SimpleTextareaResizable };
